import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const l=i("shift",t`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18104_60991"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24">
                <rect
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18104_60991)">
                <path
                    d="M8.00049 20.0002V13.0002H5.10049C4.66716 13.0002 4.36299 12.8127 4.18799 12.4377C4.01299 12.0627 4.05883 11.7085 4.32549 11.3752L11.2255 2.9502C11.4255 2.7002 11.6838 2.5752 12.0005 2.5752C12.3172 2.5752 12.5755 2.7002 12.7755 2.9502L19.6755 11.3752C19.9422 11.7085 19.988 12.0627 19.813 12.4377C19.638 12.8127 19.3338 13.0002 18.9005 13.0002H16.0005V20.0002C16.0005 20.2835 15.9047 20.521 15.713 20.7127C15.5213 20.9044 15.2838 21.0002 15.0005 21.0002H9.00049C8.71716 21.0002 8.47966 20.9044 8.28799 20.7127C8.09633 20.521 8.00049 20.2835 8.00049 20.0002ZM10.0005 19.0002H14.0005V11.0002H16.7755L12.0005 5.1502L7.22549 11.0002H10.0005V19.0002Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `),a=i("shift_filled",t`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18104_60991"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24">
                <rect
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18104_60991)">
                <path
                    d="M8.00049 20.0002V13.0002H5.10049C4.66716 13.0002 4.36299 12.8127 4.18799 12.4377C4.01299 12.0627 4.05883 11.7085 4.32549 11.3752L11.2255 2.9502C11.4255 2.7002 11.6838 2.5752 12.0005 2.5752C12.3172 2.5752 12.5755 2.7002 12.7755 2.9502L19.6755 11.3752C19.9422 11.7085 19.988 12.0627 19.813 12.4377C19.638 12.8127 19.3338 13.0002 18.9005 13.0002H16.0005V20.0002C16.0005 20.2835 15.9047 20.521 15.713 20.7127C15.5213 20.9044 15.2838 21.0002 15.0005 21.0002H9.00049C8.71716 21.0002 8.47966 20.9044 8.28799 20.7127C8.09633 20.521 8.00049 20.2835 8.00049 20.0002Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `);export{l as Shift,a as ShiftFilled};
